module.exports = __webpack_public_path__ + "img/Loaddata.1b136a43.svg";